import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../Sales.module.scss';
import classnames from 'classnames';
import {
  getItemName,
  formatNumber,
  getStoreIcon,
} from '../../Utils/dashboardUtils';

//assets
import dropdown from '../../../../assets/dropdown.svg';
import SVG from 'react-inlinesvg';

//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

//utils
import { getCountryIcon, getTransactionIcon } from './EarningsTableUtils';
import { Sale } from '../../../../sagas/dashboard/types';

interface SalesTableItemProps {
  transaction: Sale;
}

export const SalesTableItem: React.FC<SalesTableItemProps> = ({
  transaction,
}) => {
  const { t } = useTranslation();
  const cx = classnames.bind(styles);
  const [isOpen, setIsOpen] = useState(false);
  const [countryIcon, setCountryIcon] = useState('');
  const [transactionIcon, setTransactionIcon] = useState('');

  const [isDesktop, setIsDesktop] = useState(
    window.matchMedia('(min-width: 981px)').matches,
  );

  useEffect(() => {
    window
      .matchMedia('(min-width: 981px)')
      .addEventListener('change', (e) => setIsDesktop(e.matches));
  }, []);

  const storeIcon: any = useMemo(
    () => transaction && getStoreIcon(transaction.store),
    [transaction],
  );

  useEffect(() => {
    getCountryIcon(transaction.countryCode).then((res: any) =>
      setCountryIcon(res),
    );
    getTransactionIcon(transaction).then((res: any) => setTransactionIcon(res));
  }, [transaction]);

  return (
    <>
      {isDesktop ? (
        <div
          key={transaction.ID + 'desktop'}
          className={styles.tableItemDesktop}
        >
          <label className={styles.productItemName}>
            <SVG src={transactionIcon} />
            {getItemName(transaction.type, transaction.metadata, t)}
          </label>

          <label>
            {transaction.countryCode && <SVG src={countryIcon} />}
            {transaction.countryCode}
          </label>
          <label>
            <SVG src={storeIcon} /> · {transaction.store.toLowerCase()}
          </label>
          <label
            className={
              transaction.grossIncome.amount < 0
                ? styles.refund
                : styles.default
            }
          >
            {transaction.grossIncome.toString()}
          </label>
        </div>
      ) : (
        <div key={transaction.ID} className={styles.tableItemMobile}>
          <div className={styles.body} onClick={() => setIsOpen(!isOpen)}>
            <div className={styles.bodyTop}>
              <label className={styles.productItemName}>
                <SVG src={transactionIcon} />
                {getItemName(transaction.type, transaction.metadata, t)}
              </label>

              <label
                className={
                  transaction.grossIncome.amount < 0
                    ? styles.refund
                    : styles.default
                }
              >
                {transaction.grossIncome.toString()}
              </label>
              <div className={isOpen ? styles.showLess : styles.showMore}>
                <SVG src={dropdown}></SVG>
              </div>
            </div>
            <div className={styles.bodyBottom}>
              {transaction.countryCode && <SVG src={countryIcon} />}
              {transaction.countryCode}
            </div>
          </div>

          <div
            className={
              isOpen
                ? cx(styles.expandedItem, styles.expanded)
                : cx(styles.expandedItem, styles.collapsed)
            }
          >
            <div className={styles.itemDetail}>
              <div className={styles.flex}>
                <label>{tr(t, 'store')}</label>
              </div>

              <label>
                <SVG src={storeIcon} /> · {transaction.store.toLowerCase()}
              </label>
            </div>
            <div className={styles.itemDetail}>
              <div className={styles.flex}>
                <label>{tr(t, 'earnings')}</label>
              </div>

              <label
                className={
                  transaction.grossIncome.amount < 0
                    ? styles.refund
                    : styles.default
                }
              >
                {transaction.grossIncome.toString()}
              </label>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
